import _classCallCheck from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mycial-frontend/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import { getAllValidationsInArray } from "../../utils/validationUtils";
import GenericInput from "../GenericInput/GenericInput";
import SelectComponent from "../SelectComponent/SelectComponent";
import CometaSelect from "../SelectComponent/CometaSelect/CometaSelect";
import CometaSearch from "../SelectComponent/CometaSearch/CometaSearch";
import CometaIndustryCodes from "../SelectComponent/CometaIndustryCodes/CometaIndustryCodes";
import UploadFileComponent from "../UploadFileComponent/UploadFileComponent";
import RadioComponent from "../RadioComponent/RadioComponent";
import CheckboxComponent from "../CheckboxComponent/CheckboxComponent";
import CurrencyComponent from "../CurrencyComponent/CurrencyComponent";
import PercentageComponent from "../PercentageComponent/PercentageComponent";
import DateComponent from "../DateComponent/DateComponent";
import PostalCodeBraComponent from "../PostalCodeBraComponent/PostalCodeBraComponent";
import DownloadFileComponent from "../DownloadFileComponent/DownloadFileComponent";
import { getFieldItemConditionsInfo } from "../../utils/condition/selectors";
import { fieldTypes } from "../../utils/constants";

var FieldItem =
/*#__PURE__*/
function (_Component) {
  _inherits(FieldItem, _Component);

  function FieldItem() {
    _classCallCheck(this, FieldItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(FieldItem).apply(this, arguments));
  }

  _createClass(FieldItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          fieldTitle = _this$props.fieldTitle,
          fieldType = _this$props.fieldType,
          required = _this$props.required,
          conditionFail = _this$props.conditionFail,
          handleChange = _this$props.handleChange,
          listValues = _this$props.listValues,
          restrictionValidation = _this$props.restrictionValidation,
          uploadingFiles = _this$props.uploadingFiles,
          files = _this$props.files,
          note = _this$props.note,
          country = _this$props.country,
          language = _this$props.language;

      if (conditionFail) {
        return null;
      }

      var restrictions = restrictionValidation && restrictionValidation.map(function (r) {
        return {
          validationName: r
        };
      }) || [];

      if (fieldType === fieldTypes.EMAIL) {
        restrictions = restrictions.concat({
          validationName: "email"
        });
      }

      if (fieldType === fieldTypes.URL) {
        restrictions = restrictions.concat({
          validationName: "url"
        });
      }

      var fieldValidations = getAllValidationsInArray(required ? restrictions.concat({
        validationName: "required"
      }) : restrictions);
      var fieldLabel = React.createElement(Fragment, null, React.createElement("span", null, fieldTitle), required && React.createElement("span", {
        notranslate: "true"
      }, "*"));

      switch (fieldType) {
        case fieldTypes.INSTRUCTIONS:
          return React.createElement(Fragment, null, React.createElement("p", null, fieldLabel), note && React.createElement("label", null, note));

        case fieldTypes.RADIO:
          return React.createElement(RadioComponent, {
            name: id,
            validate: fieldValidations,
            label: fieldLabel,
            values: listValues,
            displayNotes: note
          });

        case fieldTypes.CHECKBOX:
          return React.createElement(CheckboxComponent, {
            name: id,
            validate: fieldValidations,
            label: fieldLabel,
            displayNotes: note
          });

        case fieldTypes.LIST:
          return React.createElement(SelectComponent, {
            id: id,
            validate: fieldValidations,
            values: listValues,
            handleChange: handleChange,
            label: fieldLabel,
            displayNotes: note,
            language: language
          });

        case fieldTypes.COMETA_SELECT:
        case fieldTypes.COMETA_SELECT_CREATABLE:
          return React.createElement(CometaSelect, {
            isCreatable: fieldType === fieldTypes.COMETA_SELECT_CREATABLE,
            name: id,
            label: fieldLabel,
            validate: fieldValidations,
            displayNotes: note,
            listName: listValues[0],
            handleChange: handleChange,
            country: country,
            language: language
          });

        case fieldTypes.COMETA_SEARCH:
        case fieldTypes.COMETA_SEARCH_CREATABLE:
          return React.createElement(CometaSearch, {
            isCreatable: fieldType === fieldTypes.COMETA_SEARCH_CREATABLE,
            name: id,
            label: fieldLabel,
            validate: fieldValidations,
            displayNotes: note,
            listName: listValues[0],
            handleChange: handleChange,
            country: country,
            language: language
          });

        case fieldTypes.COMETA_INDUSTRY:
          return React.createElement(CometaIndustryCodes, {
            name: id,
            validate: fieldValidations,
            listName: listValues[0],
            onChange: handleChange,
            country: country,
            language: language
          });

        case fieldTypes.DOCUMENT_UPLOAD:
          return React.createElement(Field, {
            name: id,
            component: UploadFileComponent,
            label: fieldLabel,
            validate: fieldValidations,
            uploadingFiles: uploadingFiles,
            files: files,
            handleChange: handleChange,
            displayNotes: note
          });

        case fieldTypes.PERCENTAGE:
          return React.createElement(PercentageComponent, {
            name: id,
            validate: fieldValidations,
            label: fieldLabel,
            displayNotes: note
          });

        case fieldTypes.PHONE:
          return React.createElement(Field, {
            type: "text",
            name: id,
            validate: fieldValidations,
            component: GenericInput,
            label: fieldLabel,
            placeholder: fieldTitle,
            displayNotes: note
          });

        case fieldTypes.DATE:
          return React.createElement(DateComponent, {
            name: id,
            restrictions: restrictions,
            validate: fieldValidations,
            label: fieldLabel,
            displayNotes: note
          });

        case fieldTypes.CURRENCY:
          return React.createElement(CurrencyComponent, {
            name: id,
            label: fieldLabel,
            handleChange: handleChange,
            displayNotes: note,
            placeholder: fieldTitle,
            validate: fieldValidations
          });

        case fieldTypes.POSTAL_CODE_BRA:
          return React.createElement(Field, {
            name: id,
            validate: fieldValidations,
            component: PostalCodeBraComponent,
            label: fieldLabel,
            displayNotes: note,
            placeholder: fieldTitle
          });

        case fieldTypes.DOWNLOAD:
          return React.createElement(Field, {
            name: id,
            validate: fieldValidations,
            component: DownloadFileComponent,
            label: fieldLabel,
            displayNotes: note,
            placeholder: fieldTitle
          });

        default:
          var type = fieldType === fieldTypes.DIGIT ? "number" : fieldType;
          return React.createElement(Field, {
            name: id,
            validate: fieldValidations,
            type: type || "text",
            component: GenericInput,
            label: fieldLabel,
            placeholder: fieldTitle,
            displayNotes: note
          });
      }
    }
  }]);

  return FieldItem;
}(Component);

FieldItem.propTypes = {
  id: PropTypes.string.isRequired,
  arrayMember: PropTypes.string,
  // path to looping group field value. If inside of looping group
  fieldTitle: PropTypes.string,
  required: PropTypes.bool,
  fieldType: PropTypes.string,
  condition: PropTypes.array,
  validations: PropTypes.array,
  listValues: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  note: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  restrictionValidation: PropTypes.arrayOf(PropTypes.string),
  uploadingFiles: PropTypes.array,
  files: PropTypes.object,
  country: PropTypes.string,
  language: PropTypes.string
};
export default connect(function (state, props) {
  var fields = props.fields,
      arrayMember = props.arrayMember,
      condition = props.condition,
      id = props.id;
  return getFieldItemConditionsInfo(state, {
    id: id,
    condition: condition,
    arrayMember: arrayMember,
    fields: fields
  });
})(FieldItem);